
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
  --layout-gap:var(
    --sic-quote-block--layout-gap,
    var(--sic-quote-block--default--layout-gap)
  );
  --icon-size:var(
    --sic-quote-block--icon-size,
    var(--sic-quote-block--default--icon-size)
  );
}
  :host blockquote{
    margin:0;
  }
.quote-block--wrapper{
  padding-top:var(--sic-quote-block--default--outer-padding);
  padding-top:var(
    --sic-quote-block--outer-padding,
    var(--sic-quote-block--default--outer-padding)
  );
  transform:scale(1);
}
.quote-block--inner{
  border-radius:var(--border-radius-rounded-default);
  overflow:hidden;
  position:relative;
}
.quote-layout.layout-has-media{
    display:grid;
    grid-template-columns:calc(1 / 3 * 100%) calc(2 / 3 * 100%);
    grid-template-rows:1fr;
    grid-column-gap:0px;
    grid-row-gap:0px;
    padding:0px;
  }
.quote-layout.layout-image-right{
    grid-template-columns:calc(2 / 3 * 100%) calc(1 / 3 * 100%);
  }
.quote-layout.layout-is-mobile{
    display:block;
  }
.quote-image{
  position:relative;
}
.quote-image,
  .quote-image picture{
    height:100%;
  }
@media (min-width: 1024px){
.quote-image{
    max-width:592px;
    margin-right:auto
}

    .layout-image-right .quote-image{
      margin-right:0;
      margin-left:auto;
    }
  }
.quote-image img{
    display:grid;
    height:100%;
    width:100%;
    object-fit:cover;
  }
.content{
  margin:0;
  font-size:var(--sic-quote-block--default--content-font-size);
  font-size:var(
    --sic-quote-block--content-font-size,
    var(--sic-quote-block--default--content-font-size)
  );
  line-height:var(--sic-quote-block--default--content-line-height);
  line-height:var(
    --sic-quote-block--content-line-height,
    var(--sic-quote-block--default--content-line-height)
  );

  padding:var(--spacing-12) var(--spacing-5) var(--spacing-4);
}
@media (min-width: 640px){
.content{
    padding:var(--spacing-15) var(--spacing-12) var(--spacing-12)
}
  }
@media (min-width: 1024px){
.content{
    padding:var(--spacing-20) var(--spacing-20) var(--spacing-15)
}
  }
@media (min-width: 1920px){
.content{
    padding:var(--spacing-20)
}
  }
.quote-layout.layout-has-media .content{
  padding:var(--spacing-8) var(--spacing-5);
}
@media (min-width: 640px){
.quote-layout.layout-has-media .content{
    padding:var(--spacing-8)
}
  }
@media (min-width: 768px){
.quote-layout.layout-has-media .content{
    padding:var(--spacing-12)
}
  }
@media (min-width: 1024px){
.quote-layout.layout-has-media .content{
    padding:var(--spacing-12) var(--spacing-15)
}
  }
@media (min-width: 1380px){
.quote-layout.layout-has-media .content{
    padding:var(--spacing-15)
}
  }
@media (min-width: 1920px){
.quote-layout.layout-has-media .content{
    padding:var(--spacing-20) var(--spacing-24)
}
  }
.quote{
  padding-block:var(--sic-quote-block--default--content-spacing);
  padding-block:var(
    --sic-quote-block--content-spacing,
    var(--sic-quote-block--default--content-spacing)
  );
}
hr{
  color:currentColor;
}
.author{
  padding-block-start:var(--sic-quote-block--default--content-spacing);
  padding-block-start:var(
    --sic-quote-block--content-spacing,
    var(--sic-quote-block--default--content-spacing)
  );
}
.attribution{
  font-style:italic;
  padding-block-start:calc(
    var(--sic-quote-block--default--content-spacing)
       / 2
  );
  padding-block-start:calc(
    var(
        --sic-quote-block--content-spacing,
        var(--sic-quote-block--default--content-spacing)
      ) / 2
  );
}
.cta{
  display:flex;
  justify-content:flex-end;
  padding-block-start:var(--sic-quote-block--default--content-spacing);
  padding-block-start:var(
    --sic-quote-block--content-spacing,
    var(--sic-quote-block--default--content-spacing)
  );
}
.layout-has-media.layout-is-mobile .cta{
    justify-content:flex-start;
  }
.quotation{
  position:fixed;
  top:0;
  color:var(--sic-icon-color);
  color:var(--sic-quote-block--quote-color, var(--sic-icon-color));
  height:var(--sic-quote-block--default--icon-size);
  height:var(
    --sic-quote-block--icon-size,
    var(--sic-quote-block--default--icon-size)
  );
  width:var(--sic-quote-block--default--icon-size);
  width:var(
    --sic-quote-block--icon-size,
    var(--sic-quote-block--default--icon-size)
  );
}
`;